import { Stack } from '@mui/material';

import { PeriodToggle } from './PeriodToggle';

type TPeriodProps = {
  yearlySelected: boolean;
  onToggle: (yearlySelected: boolean) => void;
};

export { PeriodToggle } from './PeriodToggle';

export const BillingPeriodTabs = ({ yearlySelected, onToggle }: TPeriodProps) => (
  <Stack alignItems="center" direction="row" justifyContent="center">
    <PeriodToggle yearlySelected={yearlySelected} onToggle={onToggle} />
  </Stack>
);
